import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"padding-left":"23px","padding-bottom":"12px"} }

import { reactive, ref, computed } from 'vue'
import { externalAppLogList, getexternalAppLogList } from '@/api/marketing/marketingManage'


const __default__ = { name: 'DcCosLbuInterfaceRecord' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const queryForm = reactive({
  appName: undefined,
  startTime: '',
  endTime: '',
  valueEmpty: false,
  requestContent: '',
  responseContent: ''
})

const getList = (queryForm: object, callBack: (res: any) => void) => {
  externalAppLogList(queryForm).then((res) => {
    callBack(res)
  })
}
const columns = computed(() => [
  { title: '来源系统', dataIndex: 'appName' },
  { title: '创建时间', dataIndex: 'createTime' },
  { title: '请求参数', dataIndex: 'requestContent' },
  {
    title: '结果',
    dataIndex: 'responseContent'
  }
])
const getBlackReason = async () => {
  try {
    const res = await getexternalAppLogList()
    return res.data
  } catch (error) {
    console.log('getBlackReason error: ', error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_CosApiSelect = _resolveComponent("CosApiSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: getList,
            search: queryForm,
            "onUpdate:search": _cache[6] || (_cache[6] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuInterfaceRecord"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "来源系统"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosApiSelect, {
                        api: getBlackReason,
                        "show-search": "",
                        optionFilterProp: "label",
                        value: queryForm.appName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.appName) = $event)),
                        fieldNames: { label: 'appName', value: 'appName' }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "创建时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.startTime,
                        "onUpdate:startTime": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.startTime) = $event)),
                        endTime: queryForm.endTime,
                        "onUpdate:endTime": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "requestContent",
                    label: "请求参数"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.requestContent,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.requestContent) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "responseContent",
                    label: "结果"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.responseContent,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.responseContent) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_a_checkbox, {
                      checked: queryForm.valueEmpty,
                      "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.valueEmpty) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询空值")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_zbu",
                taskType: "104",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_interface_record_export_btn']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})